import { showError } from '../../components/Messages';
import { BaseController } from './../BaseController';

export default class InstaladorNeosController extends BaseController {
  constructor(props) {
    super(props);
    this.name = 'InstaladorNeosController';
  }

  getTitulosDaTabela = () => {
    return [
      { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo', width: '15%' },
      { titulo: this.lang.telaDeCadastroDeInstalador.tipoDeInstalador, width: '15%' },
      { titulo: this.lang.telaDeCadastroDeInstalador.numeroDaVersao, width: '15%' },
      { titulo: this.lang.telaDeCadastroDeInstalador.alteracoes, width: '30%' },
      { titulo: this.lang.telaDeCadastroDeInstalador.dataDeLiberacao, width: '15%' },
      { titulo: this.lang.telaDeCadastroDeInstalador.arquivo, width: '15%' },
    ];
  };

  getDadosDaTabela = (item) => {
    return [
      item.id,
      item.tipoDeInstalador,
      item.numeroDaVersao,
      item.alteracoes,
      item.dataDeLiberacao ? new Date(item.dataDeLiberacao).toLocaleDateString() : '',
      item.arquivoDeInstalacao?.descricao,
    ];
  };

  getObjetoDeDados = () => {
    return new Promise((resolve, reject) => {
      const item = this.view.state.itemSelecionado || {};

      if (!item.tipoDeInstalador) {
        showError(this.lang.telaDeCadastroDeInstalador.mensagens.informeOTipoDoInstalador);
        reject();
        return;
      }

      if (!item.numeroDaVersao) {
        showError(this.lang.telaDeCadastroDeInstalador.mensagens.informeONumeroDaVersao);
        reject();
        return;
      }

      if (!item.dataDeLiberacao) {
        showError(this.lang.telaDeCadastroDeInstalador.mensagens.informeADataDeLiberacao);
        reject();
        return;
      }

      if (!item.alteracoes) {
        showError(this.lang.telaDeCadastroDeInstalador.mensagens.informeAsAlteracoes);
        reject();
        return;
      }

      if (!item.arquivoDeInstalacao) {
        showError(this.lang.telaDeCadastroDeInstalador.mensagens.informeOArquivoDoInstalador);
        reject();
        return;
      }

      const input = {
        tipoDeInstalador: item.tipoDeInstalador,
        numeroDaVersao: item.numeroDaVersao,
        dataDeLiberacao: item.dataDeLiberacao,
        alteracoes: item.alteracoes,
        arquivoDeInstalacao: item.arquivoDeInstalacao,
      };

      if (this.view.state.alterando) {
        input.id = parseInt(item.id);
      }
      
      resolve(input);
    });
  };
}
